import { fe$utils } from './v2-fgen-fengine.js';
console.log('[FE_tp] V 1.0.4 cj2');


function fet$unexpectedError(message) {
    console.log('Unexpected error occurred: ' + message);
    toggleError(true, message);
}
function fet$showSubmitSuccess() {
    console.log('[t_CBaW] Showing success');
    document.getElementsByClassName('loadingImg')[0].style.display = 'none';
    document.getElementById('thanks').style.display = 'inherit';
}
function fet$redirect(url) {
    console.log('[t_CBaW] Redirecting to ' + url);
    window.location.assign(url);
}
function fet$showSubmitError(errorMessage) {
    console.log('Obtained server response: ' + errorMessage);
    fe$utils.removeClass('submitting', document.getElementById('form'));
    document.getElementById('progress').style.display = 'none';
    toggleError(true, errorMessage); // This one does not show text
}

function fet$onSubmit() {
    //Show loading wheel and hide form
    document.getElementsByClassName('loadingImg')[0].style.display = 'inherit';
    document.getElementsByClassName('content')[0].style.display = 'none';
    // document.body.style.background = '#ffffff';
    document.getElementById('langs').style.display = 'none';
}
function fea$acceptSuccess() {
    fet$acceptSuccess();
}
function fet$acceptSuccess() {
    console.log('Success accepted');
    if(!window.history.back())
        window.close()
}
/* Callback to inform langs available for configuration */
function fet$langsAvailable(langs, defLang) {
    var langNode = document.getElementById('langs');
    for (var i = 0; i < langs.length; i++) {
        var d = document.createElement('div');
        var classes = 'lang';
        langNodes[langs[i]] = d;
        d.addEventListener('click', onLangChanged.bind(this, langs[i]));
        d.appendChild(document.createTextNode(langs[i]));
        if (langs[i] == defLang) {
            classes += ' selected';
        }
        d.setAttribute('class', classes);
        langNode.appendChild(d);
    }
}


function fet$onRendering(inprogress) {
    console.log('Rendering? ' + inprogress)
    if (!inprogress) {
        var logoNode = document.getElementById('logo');
        if (!logoNode.hasChildNodes()) {
            fe$utils.addClass('nologo', document.body)
        } else {
            console.log('[PG] Has logo');
        }
    }
    generateInputLabels();
    setBackgroundImage();
}

var langNodes = {}
function onLangChanged(lang) {
    console.log('Lang changed to: ' + lang);
    for (var k in langNodes) {
        if (k == lang) {
            langNodes[k].setAttribute('class', 'lang selected');
        } else {
            langNodes[k].setAttribute('class', 'lang');
        }
    }
    fe$ngine.setLanguage(lang);
}
function toggleError(visible, message) {
    var errDiv = document.getElementById('errors')
    errDiv.style.display = (visible ? 'block' : 'none');
    var errGen = document.getElementById('genericError');
    errGen.style.display = (message ? 'none' : 'block');
    var errSpec = document.getElementById('specificError');
    errSpec.style.display = (message ? 'block' : 'none');
    if (message) {
        while (errSpec.hasChildNodes()) {
            errSpec.removeChild(errSpec.firstChild);
        }
        errSpec.appendChild(document.createTextNode(message));
    }
    if (visible) {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }
}

function fet$onValidationPerformed(success, errors) {
    console.log('Validation detected with errors: ' + JSON.stringify(errors));
    toggleError(!success); // This one does not show text

}
function fet$onUnrecoverableError(code, message) {
    console.log('Detected unrecoverable error: ' + code + ' - ' + message);
    //window.location = '#uerror';
    document.getElementsByClassName('loadingImg')[0].style.display = 'none';
    document.getElementsByClassName('content')[0].style.display = 'none';
    document.getElementById('langs').style.display = 'none';
    document.getElementById('unrecoverable').style.display = 'block';
    document.getElementById('progress').style.display = 'none';

    var msgEl = document.getElementById('unrecoverable-message');
    while (msgEl.hasChildNodes()) {
        msgEl.removeChild(msgEl.firstChild);
    }
    msgEl.appendChild(document.createTextNode(message));
}

function fet$showForm() {
    document.getElementsByClassName('loadingImg')[0].style.display = 'block';
    document.getElementsByClassName('content')[0].style.display = 'block';
    document.getElementById('unrecoverable').style.display = 'none';
    document.getElementById('langs').style.display = 'block';
    document.getElementById('thanks').style.display = 'none';
}

function fet$onProgress(amount, message) {
    console.log('[TPL] Progress: ' + amount + ' - ' + message);
    var ctr = document.getElementById('progress');
    ctr.style.display = 'block';
    var bar = document.getElementById('progress-content');
    var progress = Math.floor(amount * 1000) / 10;

    bar.style.width = progress + '%';
    console.log('[TPL] Set bar to: ' + bar.style.width);
    var msg = document.getElementById('progress-message');
    while (msg.hasChildNodes()) {
        msg.removeChild(msg.childNodes[0]);
    }
    msg.appendChild(document.createTextNode(message));

    var progressLbl = document.getElementById('progress-labelout');
    while (progressLbl.hasChildNodes()) {
        progressLbl.removeChild(progressLbl.firstChild);
    }
    progressLbl.appendChild(document.createTextNode(progress + '%'));
    if (amount == 1) {
        setTimeout(function () {
            ctr.style.display = 'none';
        }, 500);
    }
}


// ---------------- HTML TEMPLATE FUNCTIONS ------------------- //

function generateInputLabels() {

    //Generate inputs floating labels
    var labels = [].concat([].slice.call(document.getElementsByClassName('FE-textR-label')),
        [].slice.call(document.getElementsByClassName('FE-dateR-label')),
        [].slice.call(document.getElementsByClassName('FE-choiceautocompleteR-label'))
    );
    for (var i = 0; i < labels.length; i++) {
        labels[i].classList.add("floating-label");
        // move label after input
        labels[i].parentNode.insertBefore(labels[i], labels[i].parentNode.lastChild);

        //Add functions to inputs
        let input = labels[i].parentNode.getElementsByTagName('input')[0];
        input.setAttribute('onfocus', 'inputOnFocus(this)'); //attribute necessary in html date inputs to clone event listeners
        input.setAttribute('onblur', 'inputOnBlur(this)');
    }

    //Add functions to selects labels
    var selects = document.getElementsByClassName("FE-choice-raw");
    for (var i = 0; i < selects.length; i++) {
        // move select to top inside div
        let select = selects[i].getElementsByTagName("select").length > 0 ? selects[i].getElementsByTagName("select")[0] : null;
        if (select != null) {
            selects[i].insertBefore(select, selects[i].firstChild);

            //Add functions to selects
            select.onfocus = inputOnFocus.bind(this, select);
            select.onblur = inputOnBlur.bind(this, select);
            // DJF fix (2243): add default class floating-label-top 
            select.classList.add("floating-label-top");
        }
    };

    //Add SPAN to raduibuttons and checkbox
    var inputsChoice = document.getElementsByTagName("input");
    let index = 0;
    for (var i = 0; i < inputsChoice.length; i++) {
        if (inputsChoice[i].type == 'radio' || inputsChoice[i].type == 'checkbox') {
            let label = document.createElement("label");
            inputsChoice[i].id = inputsChoice[i].name + index;
            label.setAttribute("for", inputsChoice[i].name + index);
            inputsChoice[i].parentNode.insertBefore(label, inputsChoice[i].nextSibling);
            index++;
        }
    }

    //Hide loading wheel and show form
    document.getElementsByClassName('loadingImg')[0].style.display = 'none';
    document.getElementsByClassName('content')[0].style.display = 'inherit';
    document.getElementsByTagName('footer')[0].style.display = 'inherit';

}

function setBackgroundImage() {
    if(document.getElementById('background').getElementsByClassName('FE-imageR-image')[0]) {
        let src = document.getElementById('background').getElementsByClassName('FE-imageR-image')[0].style.backgroundImage;
        document.body.style.background = src + " no-repeat center top fixed";
        document.body.style.backgroundSize = "142% auto";
    }else if(!document.getElementById('background').getElementsByClassName('background_alt')[0]){
        document.body.style.background = "'#de78aa' no-repeat center top fixed";
        document.body.style.backgroundSize = "142% auto";
    }
}

function inputOnFocus(el) {
    console.log('Input on focus: ' + el);
    el.classList.add("floating-label-top");
    //remove errors
    el.parentNode.parentNode.classList.remove("error");
    var errorNodes = el.parentNode.getElementsByClassName("FE-controlR-error");
    if (errorNodes.length > 0) {
        errorNodes[0].innerHTML = '';
    }

}
function inputOnBlur(el) {
    if (el.onblur) {
        if (el.value == "") {
            el.classList.remove("floating-label-top");
        }
    } else {
        if (this.value == "") {
            this.classList.remove("floating-label-top");
        }
    }
}
function stylizedChoiceOptionClicked() {
    console.log('CLICK!!')
}
      
function fet$showSuccessCookie() {
    fet$showSubmitSuccess()
    return 1;
}
      
export {
    fet$showSuccessCookie, fet$unexpectedError, fet$showSubmitSuccess, fet$redirect, fet$showSubmitError,
    fet$onSubmit, fea$acceptSuccess, fet$showForm, fet$acceptSuccess, fet$langsAvailable, fet$onRendering,
    fet$onProgress, onLangChanged, toggleError, fet$onValidationPerformed, fet$onUnrecoverableError,
    generateInputLabels, setBackgroundImage, inputOnFocus, inputOnBlur
}